var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "typeform-edit"
  }, [_c('style-bar', {
    staticClass: "mb-2",
    attrs: {
      "css-keys": ['background', 'color'],
      "mode": "text",
      "styles": _vm.localStyles
    },
    on: {
      "update:styles": function updateStyles($event) {
        _vm.localStyles = $event;
      }
    }
  }), _c('div', {
    staticClass: "form-ctn pt-3"
  }, [_c('v-text-field', {
    staticClass: "py-2 px-4",
    attrs: {
      "hide-details": "",
      "placeholder": _vm.$t('typeformedit_contact_us'),
      "label": _vm.$t('button_text')
    },
    model: {
      value: _vm.form.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  }), _c('rich-text-input', {
    staticClass: "px-4 pt-5",
    attrs: {
      "placeholder": _vm.$t('typeformedit_typeform_url_placeholder'),
      "content": _vm.form.url,
      "mode": "url",
      "json": _vm.urlContentJson,
      "label": _vm.$t('typeformedit_typeform_url')
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.form, "url", $event);
      },
      "update:json": function updateJson($event) {
        _vm.urlContentJson = $event;
      }
    }
  }), _c('v-radio-group', {
    staticClass: "py-2 px-4",
    model: {
      value: _vm.form.mode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mode", $$v);
      },
      expression: "form.mode"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('automatic'),
      "value": "scroll"
    }
  }), _c('span', {
    staticClass: "font-weight-light pl-8 pb-2"
  }, [_vm._v(_vm._s(_vm.$t('typeformedit_automatic_description')))]), _c('v-radio', {
    attrs: {
      "label": _vm.$t('manual'),
      "value": "manual"
    }
  }), _c('span', {
    staticClass: "font-weight-light pl-8 pb-2"
  }, [_vm._v(_vm._s(_vm.$t('typeformedit_manual_description')))])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }